export const currencies = ["USD", "NGN", "AED", "GBP", "EUR"];

export const languages = ["English", "Arab", "Spanish"];

//get breadcrumbs
export const getCrumbs = pathname => {
  const getHref = (arr, idx) => `/${arr.filter((_, index) => index <= idx).join("/")}`;

  const path = pathname.split("/").filter(path => !!path);

  const breadCrumbs = path.map((crumb, idx) => ({
    id: idx,
    title: crumb.replace(/-/g, " "),
    href: getHref(path, idx),
  }));

  return {
    breadCrumbs,
    pageTitle: path[path.length - 1]?.replace(/-/g, " "),
    current: path[path.length - 1]?.replace(/-/g, " "),
  };
};

//get symbol for currency
export const getCurrencySign = currency => {
  const currencies = {
    USD: "$",
    NGN: "₦",
    AED: "௹",
    GBP: "£",
    EUR: "€",
  };

  return currencies[currency];
};
